module.exports = __webpack_public_path__ + "img/ing.cc608f76.svg";